import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

export default function ReferralTable({ cmsData, tableData }): JSX.Element {
  const smartNodeLabel = cmsData.smartNodesLabel;
  const liteNodeLabel = cmsData.nodesLabel;

  const headers = [
    { label: `${cmsData.dateLabel}`, accessor: 'date' },
    { label: `${cmsData.nameLabel}`, accessor: 'name' },
    {
      label: smartNodeLabel,
      accessor: 'smartNodesPurchased',
    },
    {
      label: liteNodeLabel,
      accessor: 'liteNodesPurchased',
    },
    // {
    //   label: <PointsLabel />,
    //   accessor: 'pointsAwarded',
    // },
  ];

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead sx={{ fontWeight: 700 }}>
          <TableRow>
            {headers.map((header, i) => (
              <TableCell key={`tableHeader${i + 1}`} sx={{ fontWeight: 700 }}>
                {header.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData.map((row, i) => (
            <TableRow key={`tableRow${i + 1}`} sx={{ fontWeight: 700 }}>
              {headers.map((header, j) => (
                <TableCell key={`tableCell${i + 1}-${j + 1}`}>
                  {row[header.accessor]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
